export const i18n: Record<string, Record<string, string>> = {
    en: {
        formatError: 'Please choose the correct file format: {types}',
        sizeError: 'The file size must not exceed {size}MB.',
        maxCountError: 'You can upload up to {maxCount} file.',
        maxCountErrorPlural: 'You can upload up to {maxCount} files.',
        uploadFailed: 'Upload failed. Please try again.',
    },
    de: {
        formatError: 'Bitte wählen Sie das korrekte Dateiformat: {types}',
        sizeError: 'Die Dateigröße darf {size}MB nicht überschreiten.',
        maxCountError: 'Sie können maximal {maxCount} Datei hochladen.',
        maxCountErrorPlural: 'Sie können maximal {maxCount} Dateien hochladen.',
        uploadFailed: 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },
    fr: {
        formatError: 'Veuillez choisir le format de fichier correct : {types}',
        sizeError: 'La taille du fichier ne doit pas dépasser {size}Mo.',
        maxCountError: 'Vous pouvez téléverser jusqu’à {maxCount} fichier.',
        maxCountErrorPlural: 'Vous pouvez téléverser jusqu’à {maxCount} fichiers.',
        uploadFailed: 'Échec du téléversement. Veuillez réessayer.',
    },
    it: {
        formatError: 'Seleziona il formato di file corretto: {types}',
        sizeError: 'La dimensione del file non deve superare i {size}MB.',
        maxCountError: 'Puoi caricare al massimo {maxCount} file.',
        maxCountErrorPlural: 'Puoi caricare al massimo {maxCount} file.',
        uploadFailed: 'Caricamento non riuscito. Riprova.',
    },
    es: {
        formatError: 'Elige el formato de archivo correcto: {types}',
        sizeError: 'El tamaño del archivo no debe superar los {size}MB.',
        maxCountError: 'Puedes subir hasta {maxCount} archivo.',
        maxCountErrorPlural: 'Puedes subir hasta {maxCount} archivos.',
        uploadFailed: 'Error al subir. Inténtalo de nuevo.',
    },
    nl: {
        formatError: 'Kies het juiste bestandsformaat: {types}',
        sizeError: 'De bestandsgrootte mag niet groter zijn dan {size}MB.',
        maxCountError: 'Je kunt maximaal {maxCount} bestand uploaden.',
        maxCountErrorPlural: 'Je kunt maximaal {maxCount} bestanden uploaden.',
        uploadFailed: 'Uploaden mislukt. Probeer het opnieuw.',
    },
    mx: {
        formatError: 'Elige el formato de archivo correcto: {types}',
        sizeError: 'El tamaño del archivo no debe superar los {size}MB.',
        maxCountError: 'Puedes subir hasta {maxCount} archivo.',
        maxCountErrorPlural: 'Puedes subir hasta {maxCount} archivos.',
        uploadFailed: 'Error al subir. Inténtalo de nuevo.',
    },
    br: {
        formatError: 'Escolha o formato de arquivo correto: {types}',
        sizeError: 'O tamanho do arquivo não deve exceder {size}MB.',
        maxCountError: 'Você pode enviar no máximo {maxCount} arquivo.',
        maxCountErrorPlural: 'Você pode enviar no máximo {maxCount} arquivos.',
        uploadFailed: 'Falha no envio. Tente novamente.',
    },
    sa: {
        formatError: 'يرجى اختيار تنسيق الملف الصحيح: {types}',
        sizeError: 'يجب ألا يتجاوز حجم الملف {size} ميجابايت.',
        maxCountError: 'يمكنك تحميل ملف واحد بحد أقصى {maxCount}.',
        maxCountErrorPlural: 'يمكنك تحميل ما يصل إلى {maxCount} ملفات.',
        uploadFailed: 'فشل التحميل. يرجى المحاولة مرة أخرى.',
    },
    jp: {
        formatError: '正しいファイル形式を選択してください：{types}',
        sizeError: 'ファイルサイズは{size}MB以下にしてください。',
        maxCountError: 'アップロードできるファイルは最大{maxCount}件です。',
        maxCountErrorPlural: 'アップロードできるファイルは最大{maxCount}件です。',
        uploadFailed: 'アップロードに失敗しました。もう一度お試しください。',
    },
    kr: {
        formatError: '올바른 파일 형식을 선택해 주세요: {types}',
        sizeError: '파일 크기는 {size}MB를 초과할 수 없습니다.',
        maxCountError: '최대 {maxCount}개의 파일을 업로드할 수 있습니다.',
        maxCountErrorPlural: '최대 {maxCount}개의 파일을 업로드할 수 있습니다.',
        uploadFailed: '업로드에 실패했습니다. 다시 시도해 주세요.',
    },
    cn: {
        formatError: '请选择正确的文件格式：{types}',
        sizeError: '文件大小不能超过 {size}MB。',
        maxCountError: '最多可上传 {maxCount} 个文件。',
        maxCountErrorPlural: '最多可上传 {maxCount} 个文件。',
        uploadFailed: '上传失败，请重试。',
    },
    tw: {
        formatError: '請選擇正確的檔案格式：{types}',
        sizeError: '檔案大小不得超過 {size}MB。',
        maxCountError: '最多可上傳 {maxCount} 個檔案。',
        maxCountErrorPlural: '最多可上傳 {maxCount} 個檔案。',
        uploadFailed: '上傳失敗，請再試一次。',
    },
};

const EN_LOCALES = ['us', 'ca', 'eu', 'uk', 'au', 'za', 'ph', 'global'];

export const getUploaderText = (locale: string) => {
    if (EN_LOCALES.includes(locale)) {
        return i18n.en;
    }
    return i18n[locale] || i18n.en;
};

export const formatUploaderText = (template: string, vars: Record<string, string | number>) => {
    return Object.entries(vars).reduce((text, [key, value]) => text.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value)), template);
};
